export const en = {
  header: {
    brand: 'Doc Assist',
  },
  language: {
    label: 'Language',
  },
  consult: {
    booked: 'Anzu will speak with you in {language}.',
  },
  languages: {
    en: 'English',
    id: 'Bahasa Indonesia',
    hi: 'Hindi',
    zh: 'Mandarin',
  },
  form: {
    title: 'Patient Information',
    sessionActive: 'Session Active',
    name: {
      label: 'Preferred Name',
      placeholder: "Enter patient's full name",
      required: 'Preferred Name is required',
    },
    dateOfBirth: {
      label: 'Date of Birth',
      placeholder: 'Select date of birth',
      required: 'Date of Birth is required',
      invalid: 'Please enter a valid date of birth',
    },
    gender: {
      label: 'Gender at Birth',
      placeholder: 'Select gender at birth',
      male: 'Male',
      female: 'Female',
      required: 'Gender at Birth is required',
    },
    mode: {
      label: 'My preferred mode of communication is',
      voice: 'Voice',
      text: 'Text',
      required: 'My preferred mode of communication is required',
    },
    start: 'Start New Session',
  },
  conversation: {
    emptyVoice: 'Your conversation will appear here',
    emptyText: 'Anzu is getting ready. You can start typing below.',
    typing: 'Anzu is typing',
    you: 'You',
    anzu: 'Anzu',
    placeholder: 'Type your message...',
    send: 'Send',
  },
  session: {
    end: 'End Session',
    saving: 'Saving Session...',
    confirmBody: 'Are you sure you want to end this session? This action cannot be undone.',
    continue: 'Continue Session',
  },
  timeout: {
    title: 'Session Timeout Warning',
    inactive: 'Your session has been inactive for 60 seconds.',
    countdown: 'Your session will automatically end in {seconds} seconds.',
    hint: 'Click "Continue Session" to keep working, or allow the session to end automatically.',
    endNow: 'End Now',
  },
  errors: {
    micPermission: 'Anzu needs your microphone to hold a spoken conversation. Allow microphone access in your browser and open the link again, or restart and choose typing.',
  },
  disclaimer: {
    title: 'AIGP Health Platform General Disclaimer',
    important: 'IMPORTANT: PLEASE READ THIS DISCLAIMER CAREFULLY BEFORE USING THE AIGP HEALTH PLATFORM.',
    lead: 'By using the AIGP Health AI platform "Anzu," users acknowledge and agree to the following:',
    point1: 'This platform uses Artificial intelligence (AI) to gather your information.',
    point2: 'Information entered into the AI system will be forwarded to your treating clinician at the time of your scheduled consultation.',
    point3: 'It will not be accessed, reviewed, or acted upon by any doctor prior to your appointment.',
    point4: 'This platform is not intended for use in medical emergencies.',
    point5: 'If you are experiencing chest pain, difficulty breathing, severe bleeding, or any other serious or life-threatening condition hang up now and dial 000 immediately.',
    point6: 'If your condition worsens after completing this pre-consult session, you agree to seek emergency medical care or contact your local hospital.',
    point7: 'By continuing to use this platform, you confirm that this is not a medical emergency and that you understand Anzu is a pre-consult tool only.',
    point8: 'AIGP Health accepts no responsibility for outcomes arising from delays in care where emergency attention was required.',
    cancel: 'Cancel',
    agree: 'I Agree - Start Session',
  },
  farewell: {
    preparing: 'Preparing your summary...',
    preparingHint: 'This will only take a moment.',
    thanks: 'Thank you for using AIGP Health Doc Assist',
    loggingOut: 'Logging out...',
  },
} as const;
